<app-header flexLayout="column"></app-header>
<div flexLayout="row" fxFlex style="overflow-x: hidden;">
        <div fxFlex="0">
            <app-sidebar fxFlex></app-sidebar>
        </div>
        <div fxFlex="100" style="margin-top: 0px">
            <router-outlet></router-outlet>
        </div>
</div>